import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { UserService } from 'src/app/services';

@Component({
  selector: 'app-connected-to-quickbooks-modal',
  templateUrl: './connected-to-quickbooks-modal.component.html',
  styleUrls: ['./connected-to-quickbooks-modal.component.scss']
})
export class ConnectedToQuickbooksModalComponent implements OnInit {
  subject: Subject<boolean>;
  forConnected: boolean = true;

  constructor(public bsModalRef: BsModalRef,
    public userService: UserService) { }

  ngOnInit(): void {
  }

  /**
   * @description confirm click
   */
  confirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }
 
  /**
   * @description cancel clisk
   */
  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

}
